import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './auth.scss';
import logo from './public/sunbit-logo-with-blue-text.svg';


@CSSModules(styles, {allowMultiple: true, errorWhenNotFound: false})
class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  render() {
    return (
      <div styleName="layout">
        <div styleName="inner">

          <div styleName="auth">
            <div styleName="header">
              <img src={logo} alt="Sunbit logo"/>
            </div>
            {this.props.children}
          </div>

          <div styleName="layoutFooter">
            <span>&copy; {new Date().getFullYear()} Sunbit</span>
          </div>

        </div>
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/auth/Layout.js